// necessary set
import axios from 'axios'

// need tool or method
import { baseURL, accessToken } from '@common/Define'
import _CustomAxiosModule from '@src/common/Axios.network'

export interface InResultType {
  offset?: number
  limit?: number
}

class BaseDataService {
  axios: _CustomAxiosModule
  constructor() {
    this.axios = new _CustomAxiosModule(baseURL, accessToken())
  }

  async postAPI(apiURL: string, params: any): Promise<any> {
    try {
      const { data } = await this.axios.post(apiURL, params)
      return data
    } catch (error: any) {
      if (axios.isAxiosError(error)) {
        console.log('error==========')
        console.log(error)
        // console.log(error.code)
        // console.log(error.response?.status)
        // console.log(error.response?.data?.errorCode)
        // console.log(error.response?.data?.message)
        return error
      }
      // return e
    }
  }
  async getAPI(apiURL: string, params?: any): Promise<any> {
    try {
      const { data } = await this.axios.get(apiURL, params)
      return data
    } catch (error: any) {
      if (axios.isAxiosError(error)) {
        console.log('error==========')
        console.log(error)
        // console.log(error.code)
        // console.log(error.response?.status)
        // console.log(error.response?.data?.errorCode)
        // console.log(error.response?.data?.message)
        return error
      }
      // return e
    }
  }
}

export default BaseDataService
